// Per-user department rule (server: validator dept_match). Pure, no imports.
// Exact match, case-insensitive and trimmed, on the team config's orgAliases ∪ orgName.
// The UI shows the server's per-row departmentMatch; this copy is only the fallback for
// rows stored before the validator stamped it ('legacy' rows: a non-empty department counts as known).

export const normDept = (s) => String(s == null ? '' : s).trim().toLowerCase();

export const deptValid = (teamConfig) => {
    const cfg = teamConfig || {};
    let aliases = cfg.orgAliases || [];
    if (typeof aliases === 'string') aliases = [aliases];
    const set = new Set([...aliases, cfg.orgName].map(normDept));
    set.delete('');
    return set;
};

// 'MATCH' | 'MISMATCH' | 'UNKNOWN'. Known sources: 'cards' (server) and 'legacy' (pre-deploy rows).
export function deptMatch(teamConfig, name, source) {
    const known = source === 'cards' || source === 'legacy';
    const n = String(name == null ? '' : name).trim();
    if (!known || !n || n === 'Unknown' || n === 'N/A') return 'UNKNOWN';
    return deptValid(teamConfig).has(normDept(n)) ? 'MATCH' : 'MISMATCH';
}
